import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { ArrowForwardRounded } from "@mui/icons-material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

import JoinBG from "../../assets/homepage/join-bpohomes.jpg";
// import JoinBGMB from "../../assets/homepage/join-bpohomes-mb.jpg";
import LicenseBG from "../../assets/homepage/get-license.png";
import LicenseBGMB from "../../assets/homepage/get-license-mb.png";

export default function JoinRealty() {
  const navigate = useNavigate();

  return (
    <Container
      maxWidth="xl"
      sx={{
        position: "relative",
        py: 5,
        px: 2.5,
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <Stack gap={{ xs: 3, md: 5 }}>
          <Box
            sx={{
              display: "flex",
              alignItems: "flex-end",
              position: "relative",
              height: "430px",
              padding: { xs: 2.5, md: 4.8 },
              borderRadius: "8px",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                zIndex: -1,
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  width: "100%",
                  backgroundImage: `url(${JoinBG})`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  borderRadius: "8px",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    background:
                      "linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.95))",
                    borderRadius: "8px",
                    zIndex: 0,
                    left: 0,
                    // top: 0,
                    right: 0,
                    bottom: 0,
                    height: "60%",
                  },
                }}
              />
            </Box>
            <Stack
              gap={3}
              sx={{
                width: "100%",
              }}
            >
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.8 }}
              >
                <Stack gap={1.2}>
                  <Typography
                    variant="h4"
                    component="h2"
                    fontWeight="bold"
                    color="paper.main"
                    sx={{ fontSize: { xs: "1.75rem", md: "3rem" } }}
                  >
                    Join BPO <br /> Homes Realty
                  </Typography>

                  <Typography
                    variant="body1"
                    fontSize="18px"
                    color="paper.main"
                  >
                    Commission Caps Starting at only $2K
                  </Typography>
                </Stack>
              </motion.div>

              <Box>
                <Button
                  variant="outlined"
                  color="primary"
                  size="large"
                  sx={{
                    px: 2.5,
                    py: 1.125,
                    borderRadius: 8,
                    width: { xs: "100%", md: "auto" },
                  }}
                  onClick={() => navigate("/join-as-agent")}
                >
                  <Stack direction={"row"} alignItems={"center"} gap={1}>
                    <Typography variant="body">Join Now</Typography>
                    <ArrowForwardRounded
                      sx={{
                        color: "primary",
                      }}
                    />
                  </Stack>
                </Button>
              </Box>
            </Stack>
          </Box>

          <Box
            sx={{
              position: "relative",
              height: "430px",
              backgroundImage: {
                xs: `url(${LicenseBGMB})`,
                md: `url(${LicenseBG})`,
              },
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "top",
              display: "flex",
              alignItems: "flex-end",
              borderRadius: 2,
            }}
          >
            <Stack
              gap={3}
              sx={{
                p: { xs: 2.5, md: 4.8 },
                width: "100%",
              }}
            >
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.8 }}
              >
                <Stack gap={1.2}>
                  <Typography
                    variant="h4"
                    component="h2"
                    fontWeight="bold"
                    color="paper.main"
                    sx={{
                      fontSize: { xs: "1.75rem", md: "3rem" },
                    }}
                  >
                    Get your Real <br /> Estate License
                  </Typography>

                  <Typography
                    variant="body1"
                    fontSize="18px"
                    color="paper.main"
                  >
                    Join our Internship Program
                  </Typography>
                </Stack>
              </motion.div>

              <Box>
                <Button
                  variant="outlined"
                  color="primary"
                  size="large"
                  sx={{
                    px: 2.5,
                    py: 1.125,
                    borderRadius: 8,
                    width: { xs: "100%", md: "auto" },
                  }}
                  onClick={() => navigate("/brokerage")}
                >
                  <Stack direction={"row"} alignItems={"center"} gap={1}>
                    <Typography variant="body">Join Now</Typography>
                    <ArrowForwardRounded
                      sx={{
                        color: "primary",
                      }}
                    />
                  </Stack>
                </Button>
              </Box>
            </Stack>
          </Box>
        </Stack>
      </motion.div>
    </Container>
  );
}
